import { render, staticRenderFns } from "./GestionInicialDocumentacion.vue?vue&type=template&id=9cfb82aa&"
import script from "./GestionInicialDocumentacion.vue?vue&type=script&lang=js&"
export * from "./GestionInicialDocumentacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports